<template>
  <div class="hx-shadow-contianer">
    <h1 class="title">欢迎进入服务加+平台管理系统</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 32px;
  color: teal;
  text-align: center;
  line-height: 100px;
}
</style>
